import { ChebyshevCoefficients } from '@ootk/src/interpolator/ChebyshevCoefficients';
import { Seconds } from '@ootk/src/main';

export const plutoChebyshevCoeffs: ChebyshevCoefficients[] = [
  new ChebyshevCoefficients(
    631152000 as Seconds,
    788940000 as Seconds,
    new Float64Array([
      -5276152090.9142246, 356413952.61768574, 6468148.975214608, -140315.86395886738, -10676.099334875742, 50.912231667836508, -415.20292774836224, -407.46090284983319,
      39.622459522883098, -615.7996249039968, 981.4026214917501, -63.924029254913329,
    ]),
    new Float64Array([
      -7096994016.5889912, -263090683.59533584, 8345513.5102245649, 143356.28389403026, -2086.5486664772034, -713.85981203715005, 698.1749591668447, -506.79670818646747,
      418.85876291592916, -673.67514939308171, 175.83697616259258, -174.64347476959227,
    ]),
    new Float64Array([
      -625253413.70367253, -189548618.49225783, 719003.51278424857, 95311.843326014277, 104.92359151939552, -175.04159929503996, 170.8499018991987, -41.540262402097383,
      32.805404021839301, -238.59741326918206, -29.24476669728756, -145.38157852490744,
    ])
  ),
  new ChebyshevCoefficients(
    788940000 as Seconds,
    946728000 as Seconds,
    new Float64Array([
      -3760851919.7397251, 399222479.10580385, 4081015.3942532539, -218028.112981685, 6335.3656331062321, 2195.5460435231525, -528.91440491676326, 72.031755844751999,
      -75.307330751419073, -54.682409318288165, 778.92640223503111, 116.58655479749044,
    ]),
    new Float64Array([
      -8007370173.5121956, -191234751.24591845, 9355802.2467815075, -3876.8222435315452, -12585.337764135997, 649.51956917444863, 301.02038291295366, -608.47033096949258,
      245.78943441708881, -833.9476409753164, 278.01870282491046, -155.37347993850707,
    ]),
    new Float64Array([
      -1365384693.569926, -179733990.88985112, 1646036.7826882859, 45421.244986861944, -5180.817026313146, 271.81414087216058, -78.656688976287839, -206.80689395864803,
      -100.06005523204803, -319.55182432134944, -32.403940172990161, 3.5847263097763062,
    ])
  ),
  new ChebyshevCoefficients(
    946728000 as Seconds,
    1104516000 as Seconds,
    new Float64Array([
      -2111168664.4298639, 424252828.26413929, 2403185.2492989697, -107162.91793421905, -6224.6095795313513, -780.17361117998757, -132.58474131425223, -7.3309848229090369,
      -52.964813399314878, 272.43911375999448, 923.27379615306847, -109.0647109746933,
    ]),
    new Float64Array([
      -8624663190.9877129, -117656225.99312432, 9106943.6464617569, 19452.966475661597, 5405.9112312634788, -735.51535808245342, 159.96901013056436, -379.95903828938799,
      -58.231474637985229, -625.58078816731768, 204.80209488868712, 125.52515039443969,
    ]),
    new Float64Array([
      -2055237600.0879521, -164815616.48513749, 2116700.4208395681, 58094.285492261253, 2399.1650977969171, -163.66555579503378, -205.56527056296667, -103.90357536474863,
      -138.15657613674799, -272.29518165588377, -42.484776147206624, 40.897215950489041,
    ])
  ),
  new ChebyshevCoefficients(
    1104516000 as Seconds,
    1262304000 as Seconds,
    new Float64Array([
      -386470805.43949014, 436481428.14363956, 472087.39411977131, -206198.08938903012, -3353.5387338439623, 929.35354520877206, -449.63155965407691, 18.111060901482901,
      -33.218086485068, 68.529904357592258, 1054.4745866815249, -2.1882662534713746,
    ]),
    new Float64Array([
      -8947990581.0813122, -43863085.405892946, 9251330.1077727322, -31059.454503091176, -10130.690177059174, -681.00406157175701, 241.80284884770711, -471.31836373011271,
      326.11237916946413, -787.70801998774209, -5.7865951697031655, 24.390924072265626,
    ]),
    new Float64Array([
      -2676095377.4385643, -145038629.9839794, 2792632.7905513365, 38664.071091214813, -4623.2385644594824, -158.89657411575317, -271.45521029631294, -144.96785991191865,
      -190.87645084063212, -358.59612975120547, -250.94842916329702, -16.72392856280009,
    ])
  ),
  new ChebyshevCoefficients(
    1262304000 as Seconds,
    1420092000 as Seconds,
    new Float64Array([
      1353066178.4068506, 431713296.75214416, -1382570.3978871913, -62552.345177489515, 7298.5496793369448, -2029.9888223658006, -546.80062272250655, 17.151725414395333,
      -148.7526852319638, -139.27057075997195, 889.22399057348571, 220.64128029048442,
    ]),
    new Float64Array([
      -8981642561.3821411, 26004803.664145567, 8060469.7979846951, -105489.61508563359, 10302.775717512766, 852.99300495783484, -167.92882490158081, -307.73532438278198,
      43.480434099833168, -540.19629329045608, 115.17612358729045, 59.760173066457114,
    ]),
    new Float64Array([
      -3210417606.5622292, -122076527.29709098, 2866513.5820673783, -939.09448967774711, 3514.6306590080262, 539.37421883742013, -411.04925700823463, -127.81794403394063,
      -258.51339234511056, -251.10031257470447, -250.00973287423452, 31.132817904154461,
    ])
  ),
  new ChebyshevCoefficients(
    1420092000 as Seconds,
    1577880000 as Seconds,
    new Float64Array([
      3052926341.9538627, 417471852.47288191, -2298341.181791679, -118682.47579596042, -6309.9110731999081, 315.90663871765139, -636.24130190213521, -173.88940502802529,
      0.37105963230133054, -7.0788792848587034, 875.97627584536872, -91.230466632048291,
    ]),
    new Float64Array([
      -8753686358.8972034, 87469103.33471714, 7422177.073774687, -39895.249606736499, -3070.2976304690042, -597.78484423955285, 56.671888637542722, -531.79700660705566,
      124.39249556859335, -812.16168251037595, 40.578273804982501, 166.97612020174662,
    ]),
    new Float64Array([
      -3651799710.0105948, -98417224.404168457, 3089169.7908940157, 22092.000739693642, -1981.192996207873, -48.82381272315979, -242.17120333512625, -95.684613943099976,
      -321.16224408149719, -380.76417658329012, -437.48939596811931, -89.06390204429627,
    ])
  ),
  new ChebyshevCoefficients(
    1577880000 as Seconds,
    1735668000 as Seconds,
    new Float64Array([
      4676003616.6929684, 392762940.34543443, -3816576.850974075, -74725.783856678012, 14945.893842832247, 616.66187058289847, -994.84477206071222, 78.99831810792287,
      -180.90091592470804, 310.32066446940104, 748.03012504577634, -109.25539028644562,
    ]),
    new Float64Array([
      -8290662317.4785337, 143070084.52910787, 6247673.4438642822, -158774.54184498786, -1552.9529679457346, 2500.5609145641329, 220.37711234092711, -436.25799034436545,
      145.88978605270387, -690.55864005088802, 261.79210371971129, 43.952749490737915,
    ]),
    new Float64Array([
      -3995611464.7710342, -73546999.498118877, 3014960.2882520757, -37135.023470854758, -1763.2920490662257, 1080.2572103500365, -177.71699426174163, -174.83017636140187,
      -475.72186489899951, -276.65260698795316, -479.21031868457794, -11.858051395416259,
    ])
  ),
  new ChebyshevCoefficients(
    1735668000 as Seconds,
    1893456000 as Seconds,
    new Float64Array([
      6184303417.427598, 361320453.18837351, -3953963.0789169786, -18198.045306889217, -7758.2003739198044, 140.48635691006979, -881.86857186953227, -63.563075701395668,
      -107.24300333658854, -229.68498430252075, 857.49198436737061, 13.781106615066529,
    ]),
    new Float64Array([
      -7628154996.7941542, 187155276.34659785, 5014082.7634618441, -41155.929598204297, 3029.9420324166617, -719.49477610588076, 53.189388481775921, -561.61773602167762,
      14.077944580713908, -894.29919838905334, -131.89602146148681, 0.61184426943461101,
    ]),
    new Float64Array([
      -4243633278.1625147, -50645256.785532109, 2798825.7979089259, 5264.9414038896557, 776.03491857051847, -395.08462121486662, -237.5180984020233, -283.07200142542519,
      -388.88754568099978, -396.53212660948435, -556.23248113791146, 53.354280424118038,
    ])
  ),
  new ChebyshevCoefficients(
    1893456000 as Seconds,
    2051244000 as Seconds,
    new Float64Array([
      7562569331.2320404, 327165628.26797783, -4713781.9473200319, -84017.10209676424, 3196.9956070423127, 2003.1949151039123, -844.0811537583669, -165.65689330101014,
      -392.23195449511212, -181.31992265383403, 1027.7676070531209, 222.72130292256674,
    ]),
    new Float64Array([
      -6802808046.6422796, 224968159.19605806, 4325869.5824751062, -105372.69954307874, -9748.3060238679245, 148.07745973269144, 361.16649152437844, -555.70747235616045,
      58.508756097157793, -935.17612953186028, -34.913037427266438, -146.12385786374409,
    ]),
    new Float64Array([
      -4401270584.7083502, -28198423.620919559, 2756709.2578147729, -26405.480433781941, -4862.9619152386986, -117.20957894325257, -142.59536293347676, -321.91881622473397,
      -377.43458452224729, -453.3751545747121, -431.43682158788044, 15.705393369992574,
    ])
  ),
  new ChebyshevCoefficients(
    2051244000 as Seconds,
    2209032000 as Seconds,
    new Float64Array([
      8793251530.0858288, 288156697.21191835, -4756012.3253507297, 53607.610780350369, -4032.2181146462758, -1366.017686812083, -651.31008828481038, 105.06482663154601,
      -407.41906441052754, 111.12400546073913, 508.10244480768841, -22.698929421106975,
    ]),
    new Float64Array([
      -5843234288.3764286, 253608681.13163763, 2928569.1485776426, -58718.771163145699, 10731.552137120565, -733.93840200106297, -441.41314916610719, -304.04893914858502,
      -275.56766363779701, -767.44724782307946, -185.15636982917786, 30.844390710194904,
    ]),
    new Float64Array([
      -4472821217.3632164, -7952991.7564321514, 2329702.5985454083, -14622.988680092494, 4125.2612132072445, -542.7586060523987, -532.29988307952885, -360.1280944188436,
      -401.36924866040545, -385.1593238353729, -356.73757093747457, 217.19364409446715,
    ])
  ),
  new ChebyshevCoefficients(
    2209032000 as Seconds,
    2366820000 as Seconds,
    new Float64Array([
      9871413527.6888885, 250928837.43798956, -4751989.495687834, -54509.343569310506, -6274.2333476066588, 742.73641408284504, -798.96370410919189, 232.51125370661418,
      -308.61102705001832, 218.47494281133015, 893.35959335962934, -98.203205617268878,
    ]),
    new Float64Array([
      -4784317114.4518776, 275612626.55796659, 2610484.9702572981, -34180.722490024564, -6157.2097040017443, -610.52727168401077, -78.268901904424027, -625.45987458229069,
      -242.34678645133971, -937.46954479217527, -211.92897818883259, 47.808495632807414,
    ]),
    new Float64Array([
      -4467595427.3818321, 10564547.662505101, 2314065.2352938177, -5121.3436649799351, -3002.5850794315338, -367.42499499320985, -391.05686500867205, -380.0828624725342,
      -217.97362763086954, -507.3937122186025, -170.91058176358541, 0.68910253842671709,
    ])
  ),
  new ChebyshevCoefficients(
    2366820000 as Seconds,
    2524176000 as Seconds,
    new Float64Array([
      10794146254.094387, 210110193.66218624, -5104107.7469545044, 46729.13280541102, 10048.051551246643, -1542.7077122688293, -1669.8129636764527, 59.967458756764728,
      -668.20179611841832, -40.943299166361491, 887.14067598978681, 112.03353710174561,
    ]),
    new Float64Array([
      -3647338426.2487288, 291930445.23548621, 1505869.1003589074, -107170.41383086841, 8888.5476529121406, 1736.7892298618951, -240.06049660046895, -482.66535704930624,
      67.16378602186839, -889.8680320421854, -228.42687885761259, 59.229534244537355,
    ]),
    new Float64Array([
      -4390233900.4487362, 27780467.916430917, 1925314.5351697921, -41759.011156590779, 3174.2895405292511, 670.79778416951501, -485.35548152923582, -349.46074047088621,
      -245.41881513595581, -518.28805166880284, -247.82637162208556, -70.33865622679393,
    ])
  ),
];
